import { showToastNotification } from '../utils/utils'

export default {
  data() {
    return {
    }
  },
  methods: {

    showToastNotification(text = '', type = 'error') {
      return showToastNotification(text, type)
    },
    showSuccessNotification(text) {
      return this.showToastNotification(text, 'success')
    },
    showWarningNotification(text) {
      return this.showToastNotification(text, 'warning')
    },
    showErrorNotification(text) {
      return this.showToastNotification(text)
    },
    showConfirmDialog({ title, text } = { title: 'Are you sure?', text: "You won't be able to revert this!" }) {
      return new Promise((resolve, reject) => {
        this.$swal({
          title: this.$t(title),
          text: this.$t(text),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Yes'),
          cancelButtonText: this.$t('No'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    showConfirmWithCheckboxDialog({ title, text, inputPlaceholder } = { title: 'Are you sure?', text: "You won't be able to revert this!", inputPlaceholder: "Don't show this again" }) {
      return new Promise((resolve, reject) => {
        this.$swal({
          title: this.$t(title),
          text: this.$t(text),
          icon: 'warning',
          input: 'checkbox',
          inputPlaceholder: this.$t(inputPlaceholder),
          showCancelButton: true,
          confirmButtonText: this.$t('Yes'),
          cancelButtonText: this.$t('No'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
          inputValidator: () => null,
        }).then(result => {
          if (result.isConfirmed) {
            resolve(result.value)
          } else {
            reject()
          }
        })
      })
    },
  },
}
